/** Defines the optional tracking purposes and allow/refuse choices used across the app. */
export enum TrackingPurpose {
	UsageStatistics = "usageStatistics",
	SessionRecording = "sessionRecording",
	AdConversionMeasurement = "advertising",
	PersonalizedAdvertising = "personalizedAdvertising",
}

export type PrivacyChoices = Record<TrackingPurpose, boolean>

export const trackingPurposes = Object.values(TrackingPurpose)

export function createPrivacyChoices(allowed = false): PrivacyChoices {
	return {
		[TrackingPurpose.UsageStatistics]: allowed,
		[TrackingPurpose.SessionRecording]: allowed,
		[TrackingPurpose.AdConversionMeasurement]: allowed,
		[TrackingPurpose.PersonalizedAdvertising]: allowed,
	}
}

export function hasWithdrawnPermission(previous: PrivacyChoices, next: PrivacyChoices): boolean {
	return trackingPurposes.some(purpose => previous[purpose] && !next[purpose])
}
